import type { Option } from 'shared/models/common';
import type { Option as FilterOption } from 'shared/components/TableFilterComponent';

import isObj from './isObj';

function isRawOption<K extends string | number>(v: unknown): v is Option<K> {
  return isObj(v) && v.hasOwnProperty('Label') && v.hasOwnProperty('Value');
}

function optionsAdapter<T extends string | number>(
  options: Array<T | Option<T>>
): FilterOption<T>[] {
  return options.map((option) => {
    if (isRawOption(option)) {
      return {
        label: option.Label,
        value: option.Value,
      };
    }

    return {
      label: String(option),
      value: option,
    };
  });
}

export default optionsAdapter;
